import common from "./common.json";
import list from "./list.json";
import details from "./details.json";
import storeCredit from "./storeCredit.json";
import loyalty from "./loyalty.json";
import giftCards from "./giftCards.json";
import transactions from "./transactions.json";
import otherInfo from "./otherInfo.json";
import visits from "./visits.json";
import addCustomerForm from "./addCustomerForm.json";
import customerContact from "./customerContact.json";
import customerAddress from "./customerAddress.json";
import addCustomerGroupForm from "./addCustomerGroupForm.json";
import customerImport from "./customerImport.json";
import customerGroups from "./customerGroups.json";
import addCustomerGroup from "./addCustomerGroup.json";
import addCustomerGroupCustom from "./addCustomerGroupCustom.json";
import addCustomerGroupManual from "./addCustomerGroupManual.json";
import selectModal from "./selectModal.json";
import salesModal from "./salesModal.json";
import productSearchModal from "./productSearchModal.json";

// One JSON per screen in the Customers module; this barrel assembles them into the
// single `customers` i18n namespace. Add a screen by dropping in its JSON and
// adding it here -- src/i18n/index.ts stays untouched.
const customers = {
  common,
  list,
  details,
  storeCredit,
  loyalty,
  giftCards,
  transactions,
  otherInfo,
  visits,
  addCustomerForm,
  customerContact,
  customerAddress,
  addCustomerGroupForm,
  customerImport,
  customerGroups,
  addCustomerGroup,
  addCustomerGroupCustom,
  addCustomerGroupManual,
  selectModal,
  salesModal,
  productSearchModal,
};

export default customers;
